import React from 'react';

import { useGetPrintingOrdersListDetails } from '@/modules/packhouse/printingOrders/apiHooks';
import OrderCardContent from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders/PrintingOrderRow/OrdersList/OrderCardContent';
import WorkersTable from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders/PrintingOrderRow/OrdersList/WorkersTable';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { Loading } from '@/shared/components/atoms';
import Collapse from '@/shared/components/atoms/Collapse';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface Props {
  date: string;
  ordersData: IPrintingOrders.ISupplierOrdersItem;
}

const OrdersList: React.FC<Props> = ({ date, ordersData }) => {
  // const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data: ordersDetails, isLoading } = useGetPrintingOrdersListDetails({
    date,
    entityId: selectedAsset?.id,
    userId: ordersData?.user?.userId,
  });

  // filter orders by printingOrderId
  // if loading
  if (isLoading) {
    return <Loading />;
  }

  // // if no data found
  // if (!orders?.length && !isLoading) {
  //   return (
  //     <div className=' w-full rounded-lg bg-white px-0 py-16 text-center text-20 font-semi-bold'>
  //       {t('no-orders')}
  //     </div>
  //   );
  // }

  const getPatchOrder = (printingOrderId: string) => {
    return ordersDetails?.orders?.find(
      (item) => item?.orderId === printingOrderId
    );
  };
  return (
    <div className='flex flex-col gap-y-16'>
      {ordersData.orders?.map((order) => (
        <Collapse
          key={order?.printingOrderId}
          header={
            <OrderCardContent
              order={order}
              orderDetails={getPatchOrder(order?.printingOrderId)}
              supervisor={ordersDetails?.user}
            />
          }
          childrenPadding='px-0 py-0'
          bgColor='bg-white'
          containerPadding='px-16 py-0'
        >
          <WorkersTable
            workers={getPatchOrder(order?.printingOrderId)?.workers}
          />
        </Collapse>
      ))}
    </div>
  );
};

export default OrdersList;
